export enum SmsTemplateNames {
  smsLrpQuote = 'smsLrpQuote',
  smsCustom = 'smsCustom',
}
